import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    brand: {
      100: "#F2A3A3", // Açık ton
      200: "#E58C8C", // Orta açık ton
      300: "#E45858", // Orta ton
      400: "#D94F4F", // Orta koyu ton
      500: "#C94444", // Koyu ton
      600: "#B33D3D", // Daha koyu ton
      700: "#A33737", // Koyu ton
      800: "#8C2D2D", // Çok koyu ton
      900: "#7F2A2A", // En koyu ton
    },
    brandScheme: {
      100: "#F2A3A3",
      200: "#E58C8C",
      300: "#E45858",
      400: "#D94F4F",
      500: "#C94444",
      600: "#B33D3D",
      700: "#A33737",
      800: "#8C2D2D",
      900: "#7F2A2A",
    },
    brandTabs: {
      100: "#F2A3A3",
      200: "#E58C8C",
      300: "#E45858",
      400: "#D94F4F",
      500: "#C94444",
      600: "#B33D3D",
      700: "#A33737",
      800: "#8C2D2D",
      900: "#7F2A2A",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
